<template>
  <v-select
    v-model="data"
    v-bind="$attrs"
    :items="monthItems"
    item-text="label"
    item-value="value"
    :multiple="multi"
  />
</template>

<script>
import ModelMixin from '../../mixins/model';

export default {
  mixins: [
    ModelMixin,
  ],

  props: {
    value: [Number, Array],
    multi: Boolean,
    short: Boolean,
  },

  data() {
    return {
      data: undefined,
    };
  },

  computed: {
    monthItems() {
      const t = this.$t(''); // eslint-disable-line
      const localeData = moment.localeData();
      let x = 1;
      const months = this.short ? localeData.monthsShort() : localeData.months();
      return _.map(months, name => ({ label: name, value: x++ }));
    },
  },
};
</script>
